/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Linux_Riscv_Tar_DescInputs */

const en_pc_dl_file_linux_riscv_tar_desc = /** @type {(inputs: Pc_Dl_File_Linux_Riscv_Tar_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Needs glibc 2.39 or newer.`)
};

const zh_pc_dl_file_linux_riscv_tar_desc = /** @type {(inputs: Pc_Dl_File_Linux_Riscv_Tar_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要 glibc 2.39 或更高版本。`)
};

/**
* | output |
* | --- |
* | "Needs glibc 2.39 or newer." |
*
* @param {Pc_Dl_File_Linux_Riscv_Tar_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_linux_riscv_tar_desc = /** @type {((inputs?: Pc_Dl_File_Linux_Riscv_Tar_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Linux_Riscv_Tar_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_linux_riscv_tar_desc(inputs)
	return zh_pc_dl_file_linux_riscv_tar_desc(inputs)
});
export { pc_dl_file_linux_riscv_tar_desc as "pc.dl.file.linux_riscv_tar.desc" }